module.exports = {
    drsf_force: "Force use of this DRSF",
    lora_boot_msg: "Device send message on LoRa when boot up",
    lora_on_wifi_connect: "Device send messages on LoRa when is connected to WiFi",
    cumulative_current: "Cumulative current",
    cumulative_active_power: "Cumulative active power",
    cumulative_reactive_power: "Cumulative reactive power",
    cumulative_apparent_power: "Cumulative apparent power",
    cumulative_energy_import: "Cumulative energy import",
    cumulative_energy_export: "Cumulative energy export",
    average_of_average_voltages: "Average of average voltages",
    cumulative_average_current: "Cumulative average current",
    cumulative_average_active_power: "Cumulative average active power",
    reactive_energy: "Reactive energy",
    quadrant: "quadrant",
    overall_reactive_energy_import: "Overall reactive energy import",
    overall_reactive_energy_export: "Overall reactive energy export",
    time_scaler: "Time scaler",
    power_scaler: "Power scaler",
    lora_rssi: "LoRa received signal strength indicator",
    wifi_rssi: "WiFi received signal strength indicator",
    applications: "Applications",
    devices: "Devices",
    settings: "Settings",
    power_on: "Power on",
    power_off: "Power off",
    visible: "Visible",
    invisible: "Invisible",
    cumulative: "Cumulative"
}